var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "package-detail" },
    [
      _c(
        "div",
        { staticClass: "operation-bar" },
        [
          _c("el-alert", {
            attrs: {
              title: "券包详情",
              type: "info",
              closable: false,
              description:
                "您可以在此查看券包中包含的所有优惠券，并可以添加或移除优惠券",
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "operation-buttons" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.addCoupon },
                },
                [_vm._v("添加优惠券")]
              ),
              _vm._v(" "),
              _c("el-input", {
                staticStyle: { width: "220px", "margin-left": "10px" },
                attrs: {
                  placeholder: "搜索优惠券名称",
                  "prefix-icon": "el-icon-search",
                  clearable: "",
                  size: "small",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchCoupons($event)
                  },
                },
                model: {
                  value: _vm.searchKeyword,
                  callback: function ($$v) {
                    _vm.searchKeyword = $$v
                  },
                  expression: "searchKeyword",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.filteredCoupons,
            size: "mini",
            border: "",
            "header-cell-style": {
              backgroundColor: "#f5f7fa",
              color: "#606266",
            },
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "优惠券名称",
              "min-width": "150",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "coupon-name-link",
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.navigateToCouponDetail(scope.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(scope.row.name) + "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "couponType",
              label: "优惠类型",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: _vm.getTagType(scope.row.couponType) } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.couponTypeDesc ||
                                _vm.getCouponTypeText(scope.row.couponType)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "优惠信息", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.couponDiscount &&
                    scope.row.couponDiscount.length > 0
                      ? _c(
                          "div",
                          _vm._l(
                            scope.row.couponDiscount,
                            function (discount, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "discount-info-line",
                                },
                                [
                                  _c("i", { staticClass: "el-icon-price-tag" }),
                                  _vm._v(" "),
                                  scope.row.couponType === 1
                                    ? _c("span", [
                                        _vm._v(
                                          "满 " +
                                            _vm._s(discount.threshold) +
                                            "元减 " +
                                            _vm._s(discount.discount) +
                                            "元"
                                        ),
                                      ])
                                    : scope.row.couponType === 2
                                    ? _c("span", [
                                        _vm._v(
                                          "满 " +
                                            _vm._s(discount.threshold) +
                                            "元打 " +
                                            _vm._s(discount.discount) +
                                            "折"
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(discount.threshold) +
                                            " - " +
                                            _vm._s(discount.discount)
                                        ),
                                      ]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _c("div", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.formatCouponInfo(scope.row))),
                          ]),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "状态",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: { type: _vm.getStatusTagType(scope.row.status) },
                      },
                      [_vm._v(_vm._s(scope.row.statusDesc))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "有效期", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.validityType === 1
                      ? _c("div", [
                          _c("i", { staticClass: "el-icon-time" }),
                          _vm._v(" 领取后 "),
                          _c("b", [_vm._v(_vm._s(scope.row.validityDays))]),
                          _vm._v(" 天\n        "),
                        ])
                      : [
                          _c("div", [
                            _c("i", { staticClass: "el-icon-date" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(scope.row.validityStart))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { "margin-top": "4px" } }, [
                            _c("i", { staticClass: "el-icon-date" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(scope.row.validityEnd))
                            ),
                          ]),
                        ],
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "发放张数", width: "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: {
                        min: 1,
                        max: 9999,
                        size: "mini",
                        value: scope.row.issueCount || scope.row.quantity || 1,
                      },
                      on: {
                        change: function (value) {
                          return _vm.handleIssueCountChange(scope.row, value)
                        },
                      },
                      model: {
                        value: scope.row.issueCount,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "issueCount", $$v)
                        },
                        expression: "scope.row.issueCount",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "120",
              fixed: "right",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("remove-coupon-from-package-button", {
                      attrs: { "package-id": _vm.packageId, coupon: scope.row },
                      on: { success: _vm.handleRemoveSuccess },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.filteredCoupons.length === 0
        ? _c("div", { staticClass: "empty-block" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [5, 10, 20, 50],
              "page-size": _vm.pageData.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-content" }, [
      _c("i", { staticClass: "el-icon-document" }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无优惠券数据")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }